import { makeStyles } from 'tss-react/mui';
import { Icon } from './Icon';

type ToggleIconProps = {
  checked: boolean;
  size?: number;
};

/** On/off indicator. Mark its click target with `data-toggle-control` for hover feedback. */
export const ToggleIcon = ({ checked, size = 18 }: ToggleIconProps) => {
  const { classes, cx } = useStyles();
  return (
    <span
      data-toggle-icon
      aria-hidden
      className={cx(classes.root, checked && classes.checked)}
    >
      <Icon
        category="ui"
        icon={checked ? 'toggleOn' : 'toggleOff'}
        size={size}
      />
    </span>
  );
};

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'inline-flex',
    color: theme.palette.text.primary,
    opacity: 0.3,
    '[data-toggle-control]:hover &': { opacity: 1 },
  },
  checked: { opacity: 0.7 },
}));
